import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { AppsOutlined, ChevronRight } from '@mui/icons-material';
import { TOOLS } from '../tools/registry';
import EmptyState from '../components/EmptyState';
import { useAuthStore } from '../stores/authStore';

export default function HomePage() {
  const user = useAuthStore((s) => s.user);
  const tools = TOOLS.filter((t) => user?.tools.includes(t.id));

  return (
    <Container
      maxWidth="md"
      sx={{ py: { xs: 3, sm: 5 }, position: 'relative' }}
    >
      <Typography variant="h6" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
        Outils
      </Typography>

      {tools.length === 0 ? (
        <EmptyState icon={AppsOutlined} label="Aucun outil" />
      ) : (
        <Grid container spacing={2}>
          {tools.map((tool) => (
            <Grid item xs={12} sm={6} key={tool.id}>
              <Card
                variant="outlined"
                sx={{
                  height: '100%',
                  transition:
                    'border-color .15s, box-shadow .15s, transform .15s',
                  '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: '0 6px 20px rgba(130, 203, 22, 0.15)',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                <CardActionArea
                  component={Link}
                  to={tool.basePath}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: { xs: 2, sm: 2.5 },
                  }}
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      flexShrink: 0,
                      borderRadius: 3,
                      bgcolor: 'rgba(130, 203, 22, 0.12)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <tool.icon sx={{ color: 'primary.main', fontSize: 28 }} />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      variant="subtitle1"
                      component="h2"
                      sx={{ fontWeight: 600, lineHeight: 1.3 }}
                      noWrap
                    >
                      {tool.name}
                    </Typography>
                  </Box>
                  <ChevronRight
                    sx={{ color: 'text.disabled', flexShrink: 0 }}
                  />
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Filigrane discret en bas à droite */}
      <Box
        aria-hidden
        sx={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          width: 160,
          height: 160,
          backgroundImage: 'url(/logo-noir.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          opacity: 0.06,
          transform: 'rotate(-14deg)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
    </Container>
  );
}
